<agpr-dialog-container
    id="socialTopicReplay_dialog"
    heading="Social.agentWidget.replay.dialog.heading"
    (close)="cancel()"
>
    <agpr-scroll-panel>
        <div class='agpr-socialTopicReplay-content'>
            <p class="agpr-socialTopicReplay-message" [innerHTML]="'Social.agentWidget.replay.pastPosts.message' | localize:{name: subscription.name}"></p>
            @if (estimateToLarge) {
                <agpr-message
                    [severity]="messageSeverity.warning"
                    [bottomMargin]="false"
                >
                    <p [innerHTML]="'Social.agentWidget.replay.dialog.estimateOverCapacity' | localize:{count: estimate}"></p>
                </agpr-message>
            } @else {
                <agpr-message [severity]="messageSeverity.warning">
                    <p [innerHTML]="'Social.agentWidget.replay.quota.message' | localize"></p>
                </agpr-message>
                <agpr-message
                    [severity]="messageSeverity.info"
                >
                    <div
                        [agprLoading]="loading"
                        [agprInlineLoadingIndicator]="true"
                    ></div>
                    <p [innerHTML]="'Social.agentWidget.replay.dialog.estimateHtml' | localize:{count: estimate}"></p>
                </agpr-message>
            }
        </div>
    </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            id="socialTopicReplay_dialog_cancel"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="socialTopicReplay_dialog_ok"
            [style]="buttonTypes.primary"
            label="Social.agentWidget.replay.dialog.ok"
            [disabled]="loading || estimateToLarge || estimateFailed"
            [loading]="loading"
            (click)="ok()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
